import React from 'react';
import { FaChartLine } from 'react-icons/fa';

const NEAR_ESTIMATE_THRESHOLD = 250;

function currency(value) {
  return `$${Math.round(Number(value)).toLocaleString()}`;
}

function insightLabel(price, mestimate) {
  const difference = Number(price) - Number(mestimate);
  const amount = currency(Math.abs(difference));

  if (Math.abs(difference) < NEAR_ESTIMATE_THRESHOLD) {
    return 'Near Estimate';
  }

  return difference > 0 ? `${amount} Above Estimate` : `${amount} Below Estimate`;
}

function MarketInsight({ price, mestimateStatus, mestimate }) {
  const hasInsight = mestimateStatus === 'OK' && Number(mestimate) > 0 && Number(price) > 0;

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
        <FaChartLine className="text-slate-400" />
        Market insight
      </div>

      {hasInsight ? (
        <div className="mt-2 text-sm font-semibold text-slate-950">
          {insightLabel(price, mestimate)}
        </div>
      ) : (
        <p className="mt-2 text-sm leading-5 text-slate-700">Calculating market estimate...</p>
      )}
    </div>
  );
}

export default MarketInsight;
